module.exports = __webpack_public_path__ + "static/img/news0925b.627e4fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/news0925b.jpg
// module id = v1Vw
// module chunks = 1